import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-editor-workspace',
  host: {
    class: 'flex min-h-0 min-w-0 flex-1 flex-col',
  },
  templateUrl: './editor-workspace.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorWorkspaceComponent {
  readonly showTopPanel = input(false);
}
